/* eslint-env browser */

require('../../container/client')

const axios = require('axios')
const Counterpart = require('@gandi/counterpart').Instance

const DomHelper = require('../../client/clientjs/dom-helper')

const translate = new Counterpart()
translate.registerTranslations('en', require('./i18n/en'))
translate.registerTranslations('fr', require('./i18n/fr'))

if (window.initialState.locale.identifierShort !== translate.getLocale()) {
  translate.setLocale(window.initialState.locale.identifierShort)
}

DomHelper.onDocumentReady(() => {
  const button = DomHelper.query('#offerPecheurCom')
  if (button) {
    button.onclick = function() {
      DomHelper.addClass(DomHelper.query('#modal-coupon-pecheur'), 'active')
      axios.get('/api/affiliates/pecheurCom/coupon').then(function(response) {
        if (response && response.data) {
          const code = response.data.Code
          const discount = `${response.data.Remise}`
          const until = new Date(response.data.DateFin * 1000).toLocaleString()
          DomHelper.query('#modal-coupon-pecheur .loading').style.display = 'none'
          DomHelper.query('#modal-coupon-pecheur .result').style.display = 'initial'
          DomHelper.query('#modal-coupon-pecheur .result h3').innerHTML = code
          DomHelper.query('#modal-coupon-pecheur .result .info').innerHTML = `${translate.translate('result', {
            discountPercent: discount,
            until,
          })}<a href="https://www.pecheur.com?ref=fishfriender" target="_blank">pecheur.com</a>`
        }
      })
    }
  }
})
